import URLUtils from '@/shared/utils/URLUtils';
import { cache } from '@/shared/utils/Cache';
import { session } from '@/shared/utils/storage';
import { LoginSessionEnum } from '@/viewsH5/login/LoginUtils';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';

class LandData {
  que: Dictionary = {};

  init() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.que = URLUtils.getQueryMapAll();
    const { source, goDownload = true } = this.que;
    let sourceQuery = '';
    // 针对信息流投放，链接上有多个source的情况处理；
    if (source && Array.isArray(source) && (source as string[]).length > 1) {
      [sourceQuery] = source as string[];
    }
    cache.set('source', sourceQuery || this.que.source || 'default');
    /** 外采场景，存储外采渠道 id 信息 */
    cache.set('sourceProductId', this.que.sourceProductId || '');
    /** 外采场景，存储是否能跳转落地页 */
    cache.set('goDownload', !(goDownload === 'false'));

    const m = this.getM();
    if (m) {
      session.set(LoginSessionEnum.LoginPhone, m);
    }
  }

  /** 获取当前source值，针对提现页和 贷超页面改造
   * 贷超半流程场景，直接投放，source丢失的问题 修复
   */
  getSouce(): string {
    const { source } = URLUtils.getQueryMap();
    let soureValue = '';
    if ((window.location.hash.split('?')[0].indexOf(RouterV2Enum.applyProduct) > -1
      || window.location.hash.split('?')[0].indexOf(RouterH5Enum.home) > -1
      || window.location.hash.split('?')[0].indexOf(RouterV2Enum.dcPreApplyChoose) > -1
    )
      && source
    ) {
      soureValue = source as string || cache.get('source');
      return soureValue;
    }
    return cache.get('source') || '';
  }

  /** 获取当前sourceProductId值，针对提现页和 贷超页面改造 */
  getSourceProductId(): string {
    const { sourceProductId } = URLUtils.getQueryMap();
    let sourceProductIdValue = '';
    if ((window.location.hash.split('?')[0].indexOf(RouterV2Enum.applyProduct) > -1
      || window.location.hash.split('?')[0].indexOf(RouterH5Enum.home) > -1)
      && sourceProductId
    ) {
      sourceProductIdValue = sourceProductId as string || cache.get('sourceProductId');
      return sourceProductIdValue;
    }
    return cache.get('sourceProductId') || '';
  }

  /** 获取当前cgoDownload, 表示是否能跳转落地页 */
  getGoDownload(): boolean {
    return cache.get('goDownload');
  }

  getUrlOrign() {
    const url = `${window.location.origin}`;
    return url;
  }

  getM() {
    const m = String(this.que.m || '');
    const ma: Dictionary<string> = {};

    'abcdefghijklmnopq'.split('').forEach((z, i) => {
      ma[z] = `${i}`;
    });

    const arr: string[] = [];

    m.split('').forEach((a: string, i: number) => {
      arr[i] = ma[a];
    });

    const M = arr.join('');
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(Number(M)) && M.length === 10 ? `1${M}` : '';
  }
}

export const landData = new LandData();
